const { HomePageHandler } = require('../handlers/Xtraa/HomePageHandler');

const xtraaMapping = {
    Offer: HomePageHandler
}

module.exports = { xtraaMapping }